import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalUserGoalStatePageRoutingModule } from './modal-user-goal-state-routing.module';

import { ModalUserGoalStatePage } from './modal-user-goal-state.page';

//Material
import { MatTableModule } from '@angular/material/table';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalUserGoalStatePageRoutingModule,
    MatTableModule
  ],
  declarations: [ModalUserGoalStatePage]
})
export class ModalUserGoalStatePageModule {}
